import { createStore } from 'satcheljs';
import type CommandBarEditorStore from './schema/CommandBarEditorStore';
import type { CommandBarAction } from 'owa-mail-commandbar-actions';

const defaultCommandBarEditorStore = {
    selectedActions: [] as CommandBarAction[],
    unselectedActions: [] as CommandBarAction[],
    dragAction: null,
    keyboardModeAction: null,
    isEditing: false,
};

const store = createStore<CommandBarEditorStore>(
    'commandBarEditor',
    defaultCommandBarEditorStore
)();
export default store;
export const getStore = () => store;
